import { track } from './track';
export const analytics = ({ chord }) => (store) => (next) => (action) => {
    const previousState = store.getState();
    const result = next(action);
    const nextState = store.getState();
    try {
        track(chord, nextState, action, previousState);
    }
    catch (error) {
        console.error('Analytics Middleware Error', error);
    }
    return result;
};
